<template>
  <div class="location">
    <a
      class="getAddress"
      :href="mapHref"
      @click="toSelectAddress"
      data-stat="选择定位"
      v-if="showLocation"
    >
      <van-icon name="location" />
      <span id="loca" class="van-ellipsis">{{getCurrentCity.addr || getCurrentCity.name}}</span>
    </a>
    <a class="getAddress" @click="toSelectAddress" data-stat="选择定位" v-else>
      <van-icon name="location" />
      <span id="loca" class="van-ellipsis">{{getCurrentCityByMin.addr}}</span>
    </a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { types as Home } from "@/store/home";
const getters = mapGetters({
  getCurrentCity: Home.CURRENT_CITY,
  getCurrentCityByMin: Home.CURRENT_CITY_MIN
});
export default {
  name: "location",
  data() {
    return {
      mapHref:
        "https://apis.map.qq.com/tools/locpicker?search=1&type=0&key=OTHBZ-3VGKV-UU4P3-ULQNZ-7DPSS-KOFT4&referer=myapp",
      citylocation: null,
      pageShowCity: "",
      showLocation: true // 小程序里不显示手动选择定位
    };
  },
  computed: {
    ...getters
  },
  methods: {
    // 跳转至手动切换地址
    toSelectAddress() {
      // 小程序跳转
      if (this.$browser().miniprogram) {
        window.wx.miniProgram.navigateTo({
          url: "/pages/map/map"
        });
        return false;
      }
      // H5跳转
      else {
        let href = window.location.href;
        let urlArr = href.split("?");
        this.mapHref = this.mapHref + `&backurl=${urlArr[0]}`;
        location.href = this.mapHref;
      }
    }
  },
  mounted() {
    // 小程序中不显示H5的选择定位
    if (this.$browser().miniprogram) {
      this.showLocation = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.location {
  position: relative;
  width: 100%;
  padding: 10px 20px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: start;
  font-size: 14px;
  .van-icon-location {
    top: -2px;
    margin-right: 3px;
  }
  #loca {
    display: inline-block;
    width: 150px;
    // @include oneTextEllipsis;
  }
  .getAddress {
    color: #fff;
    font-size: 16px;
  }
}
</style>
